import React, { ReactNode } from "react";

interface BlankContainerProps {
  children: ReactNode;
  showOverflow?: boolean;
}

export const BlankContainer: React.FC<BlankContainerProps> = ({
  children,
  showOverflow = false,
}) => {
  return (
    <div className="w-full px-6 py-4">
      <div
        className={`bg-white rounded-3xl shadow-md mx-auto ${showOverflow ? "overflow-visible" : "overflow-hidden"}`}
      >
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
};
